/**
* Store for progressBar
* for sharing filesets
*/
import { EventEmitter } from 'events';
import { ACTIONS } from '../../../../SharedLibs/Constants.js';
import AppDispatcher from '../dispatchers/MessageDispatcher.js';
import { Progress } from '../../Libs/Progress.js';






// ---- For debugging ------
import { debugInit } from '../../../../SharedLibs/Debug.js';
var debug = debugInit("Progress");

var progList={};


export function getProgressById(_id) {
	return( progList[_id] );
}

export function dropProgressById(_id) {
	let p = progList[_id];
	if ( ! p )  return true;
	p.disable();
	delete (progList[_id]);
}

export function getAllProgresses(){
	return progList;
}




class ProgressStoreClass extends EventEmitter {

	constructor() {
		super();
		this.subscribe(() => this._registerToActions.bind(this))
		this.data={};
		this.setMaxListeners(200);
		this.name = "ProgressStore";
		this.progressTree = {};


	}

	subscribe(actionSubscribe) {
		this._dispatchToken = AppDispatcher.register(actionSubscribe());
	}

	addChangeListener(cb) {
		this.on('CHANGE', cb)
	}

	removeChangeListener(cb) {
		this.removeListener('CHANGE', cb);
	}

	_registerToActions(action) {
		switch(action.actionType) {

			case ACTIONS.PROGRESS.INIT :
			debug.log("init progressBar", action.data);
			this.init(action.data);
			this.emitChange({
				[action.data.object._id]: "N"
			})
			break;

			case ACTIONS.PROGRESS.START :
			debug.log("Start ProgressBar ",action.data);
			this.start( action.data._id, action.data.max, action.data.startAction );
			this.emitChange({
				[action.data._id]: "S"
			})
			break;

			case ACTIONS.PROGRESS.INCREMENT :
			debug.log("Increment ProgressBar ",action.data);
			this.increment( action.data._id );
			this.emitChange({
				[action.data._id]: "INC"
			})
			break;

			case ACTIONS.PROGRESS.ABORT :
			debug.log("Abort ProgressBar ",action.data);
			this.abort( action.data._id );
			this.emitChange({
				[action.data._id]: "ABORT"
			})
			break;

			case ACTIONS.PROGRESS.END :
			debug.log("END ProgressBar ",action.data);
			this.end( action.data._id );
			this.emitChange({
				[action.data._id]: "END"
			})
			break;

			case ACTIONS.PROGRESS.DELETE :
			debug.log("Delete ProgressBar ",action.data);
			this.delete( action.data._id );
			this.emitChange({
				[action.data._id]: "DELETE"
			})
			break;

			case ACTIONS.PROGRESS.CLEAN :
			debug.log("Clean progressBar", action.data)
			this.clean(action.data._id);
			this.emitChange({
				[action.data._id]: "CLEAN"
			})
			break;

			default:
			break;
		}
	}

	emitChange(infosOnChange) {
		debug.log(`ProgressStore emitChangeCalled`, {infos: infosOnChange, data:this.data})
		
		this.emit('CHANGE', infosOnChange);
	}

	init( data  ) {
		
		let parent = this.getParentObject(data.object)
		if(parent){
			if(!this.data[parent._id]) this.init({
				"_id": parent._id, 
				"object": parent, 
				"cancellable": data.cancellable})
		}

		

		if (!this.data[data.object._id]) {
			let prog = new Progress(data)
			this.data[data.object._id] = prog

			if(parent){
				prog.parent = this.getById(parent._id)
				this.data[parent._id].addChild(prog)
			}
		}
		return this.data[data.object._id];
	}

	getParentObject(object){
		if (object.parent) return object.parent
		if (object.parentFolder) return object.parentFolder
		if (object.fileset) return object.fileset
		return undefined
	}

	checkIfIndexIsInChilds(childs, pathElement){
		for (let child in childs){
			if (child[pathElement._id]) return true
			if (child.childs) this.checkIfIndexIsInChilds(child, pathElement)
		}
	}



	getById( _id ) { return this.data[_id] }

	getAll(){ return this.data}

	getAllTree(){ return this.progTree}

	start( _id , max, startAction ) {
		if ( ! this.data[_id] ) return false;
		if ( this.data[_id].start ( max ,startAction) ) {
			//this.emitChange();
		}
		return true;
	}

	increment( _id ) {
		if ( ! this.data[_id] ) return false;
		if ( this.data[_id].increment() ) {
			//this.emitChange();
		}
		return true;
	}

	abort( _id ) {
		if ( ! this.data[_id] ) return false;
		if ( this.data[_id].abort() ) {
			//this.emitChange();
		}
		return true;
	}

	end( _id ) {
		if ( ! this.data[_id] ) return false;
		if ( this.data[_id].end() ) {
			//this.emitChange();
		}
		return true;
	}

	delete( _id ) {
		debug.log(`try to delete ${_id} progress from `, this.data)
		if ( ! this.data[_id] ) return true;
		let resp = this.data[_id].abort();
		this.data[_id].removeFromParentChilds(_id);
		delete( this.data[_id] );
		//if ( resp == true ) this.emitChange();
		this.clean();
	}

	clean(){
		let dataCopy = {...this.data}
		for(let progId in dataCopy){
			if(!this.data[progId].data.on) delete (this.data[progId])
		}
		//this.emitChange();

	}

}

//export default new ProgressStore();
export var ProgressStore = new ProgressStoreClass();
